const { useCallback } = require('react');

const { RadioList, RadioListItem } = require('@andes/radio-list');
const { List, ListItem } = require('@andes/list');
const { Typography } = require('@andes/typography');
const { useI18n } = require('nordic/i18n');

const translate = require('../../../translation');
const { parseAmount } = require('../../../utils/currency');
const { useShippingData } = require('./useShippingData');

const isFree = (cost) => !cost;

const ShippingOptions = () => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const {
    data: {
      shippingOptions,
      currency,
      selectedShippingOption,
      isMobile,
      isDesktop,
    },
    setShippinData,
  } = useShippingData();

  const hasOneShippingOption = shippingOptions?.length === 1;
  const shippingOption = shippingOptions?.[0];

  const renderItemDescrition = useCallback(
    (cost) =>
      isFree(cost) ? (
        <Typography type="body" size="s" color="positive">
          {translations.SHIPPING_FREE}
        </Typography>
      ) : (
        <Typography
          type="body"
          size={isDesktop ? 'm' : 's'}
          color={isDesktop ? 'primary' : 'secondary'}
        >
          {parseAmount(cost, currency)}
        </Typography>
      ),
    [],
  );

  const handleSelectShippingOption = useCallback((shippingOption) => {
    setShippinData({ selectedShippingOption: shippingOption });
  }, []);

  return (
    <div className="sub-content">
      {hasOneShippingOption ? (
        <List className="mt-24i">
          <ListItem
            title={shippingOption?.name}
            description={
              isMobile ? renderItemDescrition(shippingOption?.cost) : undefined
            }
            rightContent={
              isDesktop ? renderItemDescrition(shippingOption?.cost) : undefined
            }
            className="shipping-option-one-item"
          />
        </List>
      ) : (
        <>
          <Typography className="mt-32i" size="m" type="body" weight="semibold">
            {translations.SHIPPING_OPTIONS_TITLE}
          </Typography>

          <RadioList
            defaultValue={selectedShippingOption}
            name="shipping-options"
            srLabel={translations.SHIPPING_OPTIONS_TITLE}
            withDividers
            onChange={(_, value) => handleSelectShippingOption(value)}
          >
            {shippingOptions?.map(({ id, name, cost }) => (
              <RadioListItem
                key={id}
                title={
                  <Typography size={isDesktop ? 'l' : 'm'} type="body">
                    {name}
                  </Typography>
                }
                description={
                  isMobile ? <>{renderItemDescrition(cost)}</> : undefined
                }
                value={id}
                className="shipping-option-item"
                rightContent={
                  isDesktop ? <>{renderItemDescrition(cost)}</> : undefined
                }
              />
            ))}
          </RadioList>
        </>
      )}
    </div>
  );
};

module.exports = {
  ShippingOptions,
};
